/**
 * CURS - Defer Rebuy recommendation widgets until near viewport.
 * Does NOT affect rebuy.js global load (Smart Cart, GWP, tiered progress bar).
 * Reversible via window.noguPerf.deferRebuyWidgets = false or nogu-perf-config.liquid.
 */
(function () {
  'use strict';

  if (!window.noguPerf || !window.noguPerf.deferRebuyWidgets) return;

  var DEFER_ATTR = 'data-nogu-rebuy-defer';
  var ACTIVATED = 'data-nogu-rebuy-activated';
  var ROOT_MARGIN = '200px 0px';

  function initRebuyWidget(id) {
    if (!window.Rebuy) return;

    var widgetId = parseInt(id, 10);

    if (Rebuy.widgets && typeof Rebuy.widgets.init === 'function') {
      try {
        Rebuy.widgets.init();
        return;
      } catch (_) {}
    }

    if (typeof Rebuy.init === 'function') {
      try {
        Rebuy.init();
      } catch (_) {}
    }
  }

  function activateWidget(el) {
    if (el.hasAttribute(ACTIVATED)) return;
    var id = el.getAttribute(DEFER_ATTR);
    if (!id) return;

    el.setAttribute('data-rebuy-id', id);
    el.removeAttribute(DEFER_ATTR);
    el.setAttribute(ACTIVATED, 'true');
    el.classList.remove('nogu-rebuy-widget-deferred');

    if (window.Rebuy) {
      initRebuyWidget(id);
    } else {
      document.addEventListener(
        'rebuy:load',
        function () {
          initRebuyWidget(id);
        },
        { once: true }
      );
    }
  }

  function observeWidget(el) {
    if (!('IntersectionObserver' in window)) {
      activateWidget(el);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          activateWidget(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    observer.observe(el);
  }

  function stripMainContentWidgets() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    main.querySelectorAll('[data-rebuy-id]:not([data-rebuy-keep])').forEach(function (el) {
      var id = el.getAttribute('data-rebuy-id');
      if (!id) return;
      el.setAttribute(DEFER_ATTR, id);
      el.removeAttribute('data-rebuy-id');
      el.classList.add('nogu-rebuy-widget-deferred');
    });
  }

  function initObservers() {
    document.querySelectorAll('[' + DEFER_ATTR + ']:not([' + ACTIVATED + '])').forEach(observeWidget);
  }

  stripMainContentWidgets();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObservers);
  } else {
    initObservers();
  }

  window.__noguPerfActivateRebuyWidget = activateWidget;
})();
